import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-data-privacy',
  templateUrl: './data-privacy.component.html',
  styleUrls: ['./data-privacy.component.scss']
})
export class DataPrivacyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
